export const flags = [
    {id:"en", flagPath:"/assets/img/flags/en-flag.svg"},
    {id:"it", flagPath:"/assets/img/flags/it-flag.svg"}
]